<template>
    <div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">작성자</td>
                    <td>
                        <div>
                            {{ boardData.mb_name }}({{ boardData.mb_nick }})
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">등록일</td>
                    <td>
                        <div>
                            {{ boardData.created_at }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">답변상태</td>
                    <td>
                        <div>
                            {{ boardData.isAnswer === 1 ? '답변완료' : '대기' }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">문의분류</td>
                    <td>
                        <div>
                            {{ returnCategory() }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">문의제목</td>
                    <td>
                        <div>
                            {{ boardData.qa_subject }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">문의내용</td>
                    <td>
                        <div class="d_block">
                            <div class="html_wrap" v-html="boardData.qa_content">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="boardData.hasOwnProperty('UserFile') && boardData.UserFile.length > 0">
                    <td class="c_t_title">첨부파일</td>
                    <td>
                        <div class="d_block">
                            <a class="qa_file mr45" v-for="file in boardData.UserFile" :key="`file${file.a_idx}`"
                               target="_blank"
                               :href="file.org_url">{{ file.org_name }}</a>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">답변제목</td>
                    <td>
                        <div>
                            <el-input v-model="answerTitle"></el-input>
                            <div class="input_error">{{ validation.firstError('answerTitle') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">답변내용</td>
                    <td>
                        <div>
                            <el-input id="qa_answer_content" type="textarea" v-model="answerContent">
                            </el-input>
                            <div class="input_error">{{ validation.firstError('answerContent') }}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import boardValidator from "@/mixins/validators/BoardValidator";
import summernote from "@/mixins/summernote";

export default {
    name: "BoardQaDetailComponent",
    mixins: [alertMixins, boardValidator, summernote],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        boardKey: {default: 0},
    },
    data() {
        return {
            boardData: {},
            boardType: {},
            getFunc: '',
            detailApiParamSet: {},
            getCategoryFunc: '',
            isCategory: false,
            categoryData: [],
            parsingData: {
                answerTitle: 'qa_subject',
                answerContent: 'qa_content',
            },
            writeFailTypes: {
                100: '보내는 값이 잘못 되었습니다.'
            },
            writeFailMsg: '답변을 등록 할 수 없습니다.',
            answerKey: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.getBoard();
        this.getCategory();
        this.initSummernote('qa_answer_content', '답변내용', 'answerContent');
        EventBus.$on('runQaWrite', this.runWrite);
    },
    beforeDestroy() {
        EventBus.$off('runQaWrite');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getBoard() {
            this.detailApiParamSet = {
                ip: 0,
                opa: 1,
                opf: 1,
            }
            let params = Object.assign({}, this.detailApiParamSet);
            params.id = this.boardKey;
            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$board.getQaList(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert('데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        return false;
                    }
                    this.boardData = res.List[0];

                    if (this.boardData.isAnswer === 1) {
                        this.setInitData();
                    }

                    EventBus.$emit('changeLoading', false);
                })
            } catch (e) {
                console.log((e));
                EventBus.$emit('changeLoading', false);
            }
        },

        getCategory() {
            let params = {};
            try {
                this.$api.$board.getQaCategoryList(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },

        returnCategory() {
            let cateArr = this.categoryData.filter(cate => cate.qc_idx * 1 === this.boardData.qc_idx * 1)

            if (!util.isEmpty(cateArr)) {
                return cateArr[0].qc_category;
            }
        },

        setInitData() {
            this.answerKey = this.boardData.Answer[0].qa_idx;

            // 제목
            this.answerTitle = this.boardData.Answer[0].qa_subject;

            // 내용
            this.answerContent = this.boardData.Answer[0].qa_content;
            this.answerContent = util.htmlDecode(this.answerContent);
            $('#qa_answer_content').summernote('code', this.answerContent);
            this.$forceUpdate();
        },

        _makeParams() {
            let params = {};
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })

            if (this.boardData.isAnswer === 1) {
                params.qa_idx = this.answerKey;
            } else {
                params.qa_parent = this.boardKey;
            }
            return params
        },

        _getWriteFunc() {
            if (this.boardData.isAnswer === 1) {
                return this.$api.$board.updateAnswerQa
            }
            return this.$api.$board.createAnswerQa
        },

        async runWrite() {
            let params = this._makeParams();
            let func = this._getWriteFunc();
            EventBus.$emit('changeLoading', true);

            try {
                func(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        let key = res.List;
                        if (this.boardKey !== 0) {
                            key = this.boardKey;
                        }
                        this.afterFunc(key);
                    } else {
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            } catch (e) {
                console.log(e);
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },

        returnWriteType(type) {
            if (type === 1) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },

        afterFunc() {
            let content = '저장하였습니다.';
            if (this.boardData.isAnswer === 1) {
                content = '수정완료.';
            }

            this.createAlert({
                content: content,
                hide: () => {
                    EventBus.$emit('changeLoading', false)
                    this.$router.back();
                    this.getBoard();
                }
            })
        },
    },
    watch: {
        'answerContent': {
            deep: true,
            handler: function (val, oldVal) {
            },
        },
    },
}
</script>

<style scoped>

</style>
